import { ReportSection } from '@app/components/reports/types';
import { PurchaseReportResultData } from '@shared/api/types';
import { useMemo } from 'react';
import { purchaseReportSlugs } from '../slugs';

export const purchaseReportUrls = {
  resultOverview: '#results-overview',
  emissionsOverTime: '#emissions-over-time',
  emissionsBySite: '#emissions-by-site',
  emissionsBySupplier: '#emissions-by-supplier',
  emissionsByTag: '#emissions-by-tag',

  foodAndDrink: '#food-and-drink',
  emissionsByCategory: '#emissions-by-category',
  purchasedItemsFood: '#purchased-items-food-and-drink',

  packaging: '#packaging',
  emissionsByMaterial: '#emissions-by-material',
  purchasedItemsPackaging: '#purchased-items-packaging',
};

export function usePurchaseFormattedReportSections(
  reportSections: ReportSection[],
  result: PurchaseReportResultData
) {
  return useMemo(() => {
    if (!result) return [];
    return reportSections.reduce(
      (acc: ReportSection[], section: ReportSection) => {
        // Hide sections if data is not included in the report
        if (!result.includesFood || !result.foodAndDrink) {
          section.slug === purchaseReportSlugs.foodAndDrink &&
            (section.show = false);
        }

        if (!result.includesPackaging || !result.packaging) {
          section.slug === purchaseReportSlugs.packaging &&
            (section.show = false);
        }

        section.show && acc.push(section);

        if (section.items && section.show) {
          section.items.forEach((subItem: ReportSection) => {
            if (subItem.slug === purchaseReportSlugs.emissionsOverTime) {
              result.emissionsOverTime.length < 2 && (subItem.show = false);
            }

            if (subItem.slug === purchaseReportSlugs.emissionsBySite) {
              result.emissionsBySite.filter((item) => item.name !== 'No site')
                .length < 2 && (subItem.show = false);
            }

            if (subItem.slug === purchaseReportSlugs.emissionsBySupplier) {
              result.emissionsBySupplier.length < 2 && (subItem.show = false);
            }

            if (subItem.slug === purchaseReportSlugs.emissionsByTag) {
              result.emissionsByTag.length < 2 && (subItem.show = false);
            }

            subItem.show && acc.push(subItem);
          });
        }

        return acc;
      },
      []
    ) as ReportSection[];
  }, [reportSections, result]);
}
